import { render, staticRenderFns } from "./grassRoots.vue?vue&type=template&id=184a9512&scoped=true&"
import script from "./grassRoots.vue?vue&type=script&lang=js&"
export * from "./grassRoots.vue?vue&type=script&lang=js&"
import style0 from "./grassRoots.vue?vue&type=style&index=0&id=184a9512&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184a9512",
  null
  
)

export default component.exports